import React, { useState } from "react";
import Footer from "../../components/footer/Footer";
import Box from "@mui/material/Box";
import "./AiChecker.css";
import { IoCloudUploadOutline } from "react-icons/io5";
import { Button } from "@mui/material";
import axios from "axios";
import { Spinner } from "react-bootstrap";

function AiChecker() {
    const [AiChecker, setAiChecker] = useState("");
    const [output, setOutput] = useState("You will get your output here...");
    const [loading, setLoading] = useState(false);
    const [Humanloading, setHumanloading] = useState(false);
    const [AiGenerated, setAiGenerated] = useState(false);

    const countWords = (text) => {
        const words = text.trim().split(/\s+/);
        return words.length;
    };

    function handleAIGenerateContent() {
        setHumanloading(true);
    }

    const handleAICheck = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("text", AiChecker);
        formData.append("image", null);
        await axios
            .post("http://localhost:5000/detect", formData)
            .then((response) => {
                console.log(response);
                let output =
                    "Your text is " +
                    response.data.originalityai.items[0].prediction +
                    "!";
                if (
                    response.data.originalityai.items[0].prediction ===
                    "ai-generated"
                ) {
                    setAiGenerated(true);
                }
                setOutput(output);
            })
            .finally(() => {
                setLoading(false);
            });
        // setOutput(`AI checked. Results here.`);
    };

    function countCharacters(text) {
        // Remove any HTML tags from the text
        const strippedText = text.replace(/<[^>]+>/g, "");

        // Count the characters in the stripped text
        const characterCount = strippedText.length;

        return characterCount;
    }

    const maxWordCount = 1000;
    const maxCharacterCount = 15000;

    return (
        <>
            <div className="TextAreaDiv">
                <Box className="InputBox">
                    <textarea
                        name="AiCheckerText"
                        id="aichecker"
                        cols="30"
                        rows="10"
                        className="inputChecker"
                        placeholder="Input Your first Text here..."
                        value={AiChecker}
                        onChange={(e) => {
                            const inputText = e.target.value;
                            if (
                                countWords(inputText) <= maxWordCount &&
                                countCharacters(inputText) <= maxCharacterCount
                            ) {
                                setAiChecker(inputText);
                            }
                        }}
                    ></textarea>
                    <div className="buttonContainer">
                        <label htmlFor="uploadDoc" className="uploadButton">
                            <IoCloudUploadOutline className="uploadIcon" />
                            Upload a Doc
                            <input
                                type="file"
                                name="UploadDoc"
                                id="uploadDoc"
                                className="uploadInput"
                            />
                        </label>
                        <Button
                            className="AiCheckerButton"
                            variant="contained"
                            onClick={handleAICheck}
                        >
                            {loading && (
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{
                                        marginRight: 20,
                                        color: "#fff",
                                    }}
                                />
                            )}
                            {loading ? "Checking..." : "Check AI"}
                        </Button>
                    </div>
                    <p className="wordCount">
                        Word Count: {countWords(AiChecker)}
                    </p>
                    <p className="CharacterCount">
                        Character Count: {countCharacters(AiChecker)}
                        /15000
                    </p>
                </Box>
                <Box className="OutputBox">
                    <textarea
                        name="AiCheckerText"
                        id="aichecker"
                        cols="30"
                        rows="10"
                        readOnly
                        value={output}
                        className="OutputText"
                    ></textarea>
                    {AiGenerated && (
                        <div className="buttonContainer">
                            <Button
                                className="AiCheckerButton"
                                variant="contained"
                                onClick={handleAIGenerateContent}
                            >
                                {Humanloading && (
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        style={{
                                            marginRight: 20,
                                            color: "#fff",
                                        }}
                                    />
                                )}
                                {Humanloading ? "Humanizing..." : "Humanize"}
                            </Button>
                        </div>
                    )}
                </Box>
            </div>
            <Footer />
        </>
    );
}

export default AiChecker;
